export const ACCOUNTTYPES = {
  INDIVIDUAL: 'individual',
  SMSF: 'smsf',
  MINOR: 'minor',
  JOINT: 'joint',
  CORPORATE: 'corporate',
  TRUST: 'trust'
};
